var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-8 pl-1" },
      [
        _c(
          "b-form-group",
          { attrs: { label: "Aduana coordinadora" } },
          [
            _c(
              "v-select",
              {
                attrs: {
                  options: _vm.customsCompanies,
                  name: "managingCustoms",
                  reduce: function(option) {
                    return option.value
                  }
                },
                on: { input: _vm.onServerChange },
                model: {
                  value: _vm.serverConfig.gestoraId,
                  callback: function($$v) {
                    _vm.$set(_vm.serverConfig, "gestoraId", $$v)
                  },
                  expression: "serverConfig.gestoraId"
                }
              },
              [
                _c(
                  "span",
                  { attrs: { slot: "no-options" }, slot: "no-options" },
                  [_vm._v(" No hay coincidencias ")]
                )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }